// extracted by mini-css-extract-plugin
module.exports = {"touchable":"MyTouchable_touchable__3TsFa"};